import React from "react";

const UserSquareIconDark = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
    >
      <g clip-path="url(#clip0_3578_11425)">
        <path
          d="M61.7147 48.0002V57.143C61.7147 58.3554 61.2331 59.5182 60.3758 60.3755C59.5184 61.2328 58.3557 61.7145 57.1433 61.7145H48.0004M48.0004 2.28589H57.1433C58.3557 2.28589 59.5184 2.76752 60.3758 3.62483C61.2331 4.48214 61.7147 5.6449 61.7147 6.85732V16.0002M2.28613 16.0002V6.85732C2.28613 5.6449 2.76776 4.48214 3.62507 3.62483C4.48238 2.76752 5.64514 2.28589 6.85756 2.28589H16.0004M16.0004 61.7145H6.85756C5.64514 61.7145 4.48238 61.2328 3.62507 60.3755C2.76776 59.5182 2.28613 58.3554 2.28613 57.143V48.0002"
          stroke="url(#paint0_linear_3578_11425)"
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M32.0003 29.7144C37.0497 29.7144 41.1431 25.621 41.1431 20.5716C41.1431 15.5221 37.0497 11.4287 32.0003 11.4287C26.9508 11.4287 22.8574 15.5221 22.8574 20.5716C22.8574 25.621 26.9508 29.7144 32.0003 29.7144Z"
          stroke="#09090B"
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M46.4461 48C45.1461 45.27 43.0992 42.9644 40.5425 41.3501C37.9858 39.7358 35.0241 38.879 32.0004 38.879C28.9767 38.879 26.015 39.7358 23.4583 41.3501C20.9016 42.9644 18.8547 45.27 17.5547 48"
          stroke="#09090B"
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_3578_11425"
          x1="2.28613"
          y1="31.6736"
          x2="61.7147"
          y2="31.6736"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#42E6FF" />
          <stop offset="1" stopColor="#8B5EF7" />
        </linearGradient>
        <clipPath id="clip0_3578_11425">
          <rect width="64" height="64" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default UserSquareIconDark;
